/**
 * Reading Seat Assignments out of what `BLN_ASC_GetTables` returns.
 *
 * This is kept apart from the adapter that does the call because it is pure:
 * rows in, assignments out, no transport. The Design seam imports it, and that
 * seam is covered in a `node` test environment, so it must not drag the HTTP
 * client — and with it axios and the host-app globals — into those suites.
 */

import { FetchedAssignment } from './types';

/**
 * The Ticket-to-`SeatNo` assignments carried by those rows. A later row for the
 * same Ticket wins, so an attendee ends up at the Table they were most recently
 * assigned to.
 */
export function assignmentsFromRows(rows: any[]): FetchedAssignment[] {
  const assignments: FetchedAssignment[] = [];
  (rows || []).forEach((row: any) => {
    const seatNo = `${row?.seat ?? ''}`;
    if (!Array.isArray(row?.tclist)) return;
    row.tclist.forEach((ticket: any) => {
      if (ticket?.ticketid) {
        assignments.push({ ticketId: ticket.ticketid, seatNo });
      }
    });
  });
  return assignments;
}
